// How a record reads in the UI and in an exported PGN. Names are resolved
// here, at display time, so a hot-seat or bot game follows the current
// language instead of freezing the one it was played in.
import { t } from '../i18n/I18n.js';
import type { Color } from '../game/types.js';
import { recordOutcome } from './record.js';
import type { GameRecord } from './types.js';

export function playerLabel(record: GameRecord, color: Color): string {
  const name = (color === 'w' ? record.players.white : record.players.black).trim();
  if (name !== '') return name;
  const { mode, difficulty, localColor } = record.seed;
  if (mode === 'bot' && difficulty !== null && color !== localColor) {
    return t('historyList.botName', { level: t(`settings.difficulties.${difficulty}`) });
  }
  return t(color === 'w' ? 'common.white' : 'common.black');
}

export function resultLabel(record: GameRecord): string {
  const { winner } = recordOutcome(record);
  return winner === null ? t('historyList.draw') : t('historyList.winnerTemplate', { name: playerLabel(record, winner) });
}

/** Full moves played: the count a player would say, not plies. */
export function fullMoveCount(record: GameRecord): number {
  return Math.ceil(record.moves.length / 2);
}
